/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { type TApplication } from '@/interfaces'

const STORE_NAME = 'sessions'
const DB_NAME = 'VIVA_SESSIONS'

export const openSessionsDB = async () => {
  return await new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)

    // Se ejecuta cuando la base de datos se crea o se actualiza
    request.onupgradeneeded = (_) => {
      const db = request.result

      db.createObjectStore(STORE_NAME, { keyPath: 'id' })
    }

    request.onsuccess = () => resolve(request.result)
    request.onerror = (_) => reject(request.error)
  })
}

export const getAllFromStore = async (storeName: string = STORE_NAME) => {
  const db = await openSessionsDB()
  return await new Promise<TApplication[]>((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readonly')
    const store = transaction.objectStore(storeName)
    const request = store.openCursor()
    const result: TApplication[] = []

    request.onsuccess = () => {
      const cursor = request.result
      if (cursor) {
        result.push(cursor.value as TApplication)
        cursor.continue()
      } else {
        resolve(result)
      }
    }

    request.onerror = (_) => reject(request.error)
  })
}

interface TDeleteFromStoreProps {
  key?: string
  storeName?: string
}
export const deleteFromStore = async ({
  key,
  storeName = STORE_NAME,
}: TDeleteFromStoreProps) => {
  const db = await openSessionsDB()

  return await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readwrite')
    const store = transaction.objectStore(storeName)

    if (key) {
      store.delete(key)
    }

    transaction.oncomplete = () => resolve()
    transaction.onerror = (_) => reject(transaction.error)
  })
}

export const saveToStore = async (
  sessionData: TApplication,
  storeName: string = STORE_NAME
) => {
  const db = await openSessionsDB()

  return await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readwrite')

    const itemsStore = transaction.objectStore(storeName)

    itemsStore.put(sessionData)

    transaction.oncomplete = () => resolve()
    transaction.onerror = (_) => reject(transaction.error)
  })
}

const sessionsDB = {
  deleteFromStore,
  getAllFromStore,
  saveToStore,
}

export default sessionsDB
